"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMapParams = exports.UrlParamsTypes = void 0;
const lodash_1 = require("lodash");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const CrowdMapGridSize_1 = require("../components/molecules/SessionFilters/CrowdMapGridSize");
const SensorFilter_1 = require("../components/molecules/SessionFilters/SensorFilter");
const YearPickerButtons_1 = require("../components/molecules/SessionFilters/YearPickerButtons");
const mapConfigs_1 = require("../components/organisms/Map/mapUtils/mapConfigs");
const booleans_1 = require("../const/booleans");
const coordinates_1 = require("../const/coordinates");
const hooks_1 = require("../store/hooks");
const thresholdSlice_1 = require("../store/thresholdSlice");
const filters_1 = require("../types/filters");
const sensors_1 = require("../types/sensors");
const userStates_1 = require("../types/userStates");
const useScreenSizeDetection_1 = __importDefault(require("../utils/useScreenSizeDetection"));
const Cookies = __importStar(require("./cookies"));
const setSensor_1 = require("./setSensor");
var UrlParamsTypes;
(function (UrlParamsTypes) {
    UrlParamsTypes["boundEast"] = "boundEast";
    UrlParamsTypes["boundNorth"] = "boundNorth";
    UrlParamsTypes["boundSouth"] = "boundSouth";
    UrlParamsTypes["boundWest"] = "boundWest";
    UrlParamsTypes["city"] = "city";
    UrlParamsTypes["currentCenter"] = "currentCenter";
    UrlParamsTypes["currentUserSettings"] = "currentUserSettings";
    UrlParamsTypes["currentZoom"] = "currentZoom";
    UrlParamsTypes["fetchedSessions"] = "fetchedSessions";
    UrlParamsTypes["gridSize"] = "gridSize";
    UrlParamsTypes["isActive"] = "isActive";
    UrlParamsTypes["isIndoor"] = "isIndoor";
    UrlParamsTypes["limit"] = "limit";
    UrlParamsTypes["mapType"] = "mapType";
    UrlParamsTypes["measurementType"] = "measurementType";
    UrlParamsTypes["offset"] = "offset";
    UrlParamsTypes["previousCenter"] = "previousCenter";
    UrlParamsTypes["previousUserSettings"] = "previousUserSettings";
    UrlParamsTypes["previousZoom"] = "previousZoom";
    UrlParamsTypes["sensorName"] = "sensorName";
    UrlParamsTypes["sessionId"] = "sessionId";
    UrlParamsTypes["sessionType"] = "sessionType";
    UrlParamsTypes["streamId"] = "streamId";
    UrlParamsTypes["thresholdMin"] = "thresholdMin";
    UrlParamsTypes["thresholdLow"] = "thresholdLow";
    UrlParamsTypes["thresholdMiddle"] = "thresholdMiddle";
    UrlParamsTypes["thresholdHigh"] = "thresholdHigh";
    UrlParamsTypes["thresholdMax"] = "thresholdMax";
    UrlParamsTypes["unitSymbol"] = "unitSymbol";
    UrlParamsTypes["usernames"] = "usernames";
    UrlParamsTypes["tags"] = "tags";
    UrlParamsTypes["timeFrom"] = "timeFrom";
    UrlParamsTypes["timeTo"] = "timeTo";
})(UrlParamsTypes || (exports.UrlParamsTypes = UrlParamsTypes = {}));
const useMapParams = () => {
    const defaultThresholds = (0, hooks_1.useAppSelector)(thresholdSlice_1.selectDefaultThresholds);
    const thresholdValues = (0, hooks_1.useAppSelector)(thresholdSlice_1.selectThresholds);
    const isMobile = (0, useScreenSizeDetection_1.default)();
    const [searchParams, setSearchParams] = (0, react_router_dom_1.useSearchParams)();
    const getParam = (0, react_1.useCallback)((param, defaultValue) => {
        const cookieValue = Cookies.get(param);
        if (searchParams.get(param)) {
            return searchParams.get(param);
        }
        else if (cookieValue !== null) {
            return cookieValue;
        }
        else {
            return defaultValue;
        }
    }, [searchParams, setSearchParams]);
    const setUrlParams = (0, react_1.useCallback)((params) => {
        const newSearchParams = new URLSearchParams(searchParams.toString());
        params.forEach(({ key, value }) => {
            newSearchParams.set(key, value);
        });
        setSearchParams(`?${newSearchParams.toString()}`);
    }, [searchParams, setSearchParams]);
    const boundEast = parseFloat(getParam(UrlParamsTypes.boundEast, coordinates_1.DEFAULT_MAP_BOUNDS.east.toString()));
    const boundNorth = parseFloat(getParam(UrlParamsTypes.boundNorth, coordinates_1.DEFAULT_MAP_BOUNDS.north.toString()));
    const boundSouth = parseFloat(getParam(UrlParamsTypes.boundSouth, coordinates_1.DEFAULT_MAP_BOUNDS.south.toString()));
    const boundWest = parseFloat(getParam(UrlParamsTypes.boundWest, coordinates_1.DEFAULT_MAP_BOUNDS.west.toString()));
    const currentCenter = (0, react_1.useMemo)(() => JSON.parse(getParam(UrlParamsTypes.currentCenter, JSON.stringify(coordinates_1.DEFAULT_MAP_CENTER))), [searchParams]);
    const currentUserSettings = getParam(UrlParamsTypes.currentUserSettings, userStates_1.UserSettings.MapView);
    const currentZoom = parseFloat(getParam(UrlParamsTypes.currentZoom, coordinates_1.DEFAULT_ZOOM.toString()));
    const city = searchParams.get(UrlParamsTypes.city);
    const removeCityParam = (0, react_1.useCallback)(() => {
        setSearchParams((prev) => {
            const newParams = new URLSearchParams(prev);
            newParams.delete(UrlParamsTypes.city);
            return newParams;
        }, { replace: true });
    }, [setSearchParams]);
    const isIndoor = getParam(UrlParamsTypes.isIndoor, booleans_1.FALSE);
    const currentYear = new Date().getFullYear();
    const gridSize = parseInt(getParam(UrlParamsTypes.gridSize, CrowdMapGridSize_1.defaultGridSize.toString()));
    const sessionType = (0, react_1.useMemo)(() => getParam(UrlParamsTypes.sessionType, filters_1.SessionTypes.FIXED), [searchParams]);
    const isActive = (0, react_1.useMemo)(() => {
        const activeParam = getParam(UrlParamsTypes.isActive, booleans_1.TRUE);
        if (sessionType === filters_1.SessionTypes.MOBILE) {
            return true;
        }
        return activeParam === booleans_1.TRUE;
    }, [searchParams, sessionType]);
    const limit = parseInt(getParam(UrlParamsTypes.limit, !isActive ? "1000" : "100"));
    const updateLimit = (0, react_1.useCallback)((newLimit) => {
        setUrlParams([{ key: UrlParamsTypes.limit, value: newLimit.toString() }]);
    }, [setUrlParams]);
    const mapTypeId = getParam(UrlParamsTypes.mapType, mapConfigs_1.MAP_CONFIGS[0].mapTypeId) ||
        mapConfigs_1.MAP_CONFIGS[0].mapTypeId;
    const measurementType = getParam(UrlParamsTypes.measurementType, filters_1.ParameterTypes.PARTICULATE_MATTER);
    const offset = parseInt(getParam(UrlParamsTypes.offset, "0"));
    const updateOffset = (0, react_1.useCallback)((newOffset) => {
        setUrlParams([
            { key: UrlParamsTypes.offset, value: newOffset.toString() },
        ]);
    }, [setUrlParams]);
    const fetchedSessions = parseInt(getParam(UrlParamsTypes.fetchedSessions, "0"));
    const updateFetchedSessions = (0, react_1.useCallback)((newFetchedSessions) => {
        setUrlParams([
            {
                key: UrlParamsTypes.fetchedSessions,
                value: newFetchedSessions.toString(),
            },
        ]);
    }, [setUrlParams]);
    const previousCenter = (0, react_1.useMemo)(() => JSON.parse(getParam(UrlParamsTypes.previousCenter, JSON.stringify(coordinates_1.DEFAULT_MAP_CENTER))), [searchParams]);
    const previousUserSettings = getParam(UrlParamsTypes.previousUserSettings, userStates_1.UserSettings.MapView);
    const updatePreviousUserSettings = (0, react_1.useCallback)((selectedPreviousUserSettings) => {
        setUrlParams([
            {
                key: UrlParamsTypes.previousUserSettings,
                value: selectedPreviousUserSettings,
            },
        ]);
    }, [setUrlParams]);
    const previousZoom = parseFloat(getParam(UrlParamsTypes.previousZoom, coordinates_1.DEFAULT_ZOOM.toString()));
    const sensorName = getParam(UrlParamsTypes.sensorName, sensors_1.SENSOR_NAMES.PARTICULATE_MATTER.GOVERNMENT_PM25);
    const sessionId = getParam(UrlParamsTypes.sessionId, null) !== null
        ? parseInt(getParam(UrlParamsTypes.sessionId, "0"))
        : null;
    const updateSessionType = (0, react_1.useCallback)((selectedSessionType) => {
        setUrlParams([
            { key: UrlParamsTypes.sessionType, value: selectedSessionType },
            {
                key: UrlParamsTypes.previousUserSettings,
                value: currentUserSettings,
            },
            {
                key: UrlParamsTypes.currentUserSettings,
                value: isMobile ? userStates_1.UserSettings.FiltersView : userStates_1.UserSettings.MapView,
            },
            {
                key: UrlParamsTypes.sessionId,
                value: "",
            },
            {
                key: UrlParamsTypes.streamId,
                value: "",
            },
            {
                key: UrlParamsTypes.measurementType,
                value: filters_1.ParameterTypes.PARTICULATE_MATTER,
            },
            {
                key: UrlParamsTypes.sensorName,
                value: selectedSessionType === filters_1.SessionTypes.FIXED
                    ? sensors_1.SENSOR_NAMES.PARTICULATE_MATTER.GOVERNMENT_PM25
                    : sensors_1.SENSOR_NAMES.PARTICULATE_MATTER.AIRBEAM_PM25,
            },
            {
                key: UrlParamsTypes.unitSymbol,
                value: filters_1.UnitSymbols.ParticulateMatter,
            },
            {
                key: UrlParamsTypes.usernames,
                value: "",
            },
            {
                key: UrlParamsTypes.tags,
                value: "",
            },
            {
                key: UrlParamsTypes.isIndoor,
                value: booleans_1.FALSE,
            },
            { key: UrlParamsTypes.isActive, value: booleans_1.TRUE },
            {
                key: UrlParamsTypes.timeFrom,
                value: (0, YearPickerButtons_1.beginningOfTheYear)((0, YearPickerButtons_1.getAvailableYears)()[0]).toString(),
            },
            {
                key: UrlParamsTypes.timeTo,
                value: (0, YearPickerButtons_1.endOfTheYear)((0, YearPickerButtons_1.getAvailableYears)()[0]).toString(),
            },
        ]);
    }, [currentUserSettings, setUrlParams]);
    const updateIsActive = (0, react_1.useCallback)((newIsActive) => {
        if (sessionType === filters_1.SessionTypes.MOBILE) {
            newIsActive = true;
        }
        setUrlParams([
            {
                key: UrlParamsTypes.previousUserSettings,
                value: currentUserSettings,
            },
            {
                key: UrlParamsTypes.currentUserSettings,
                value: isMobile
                    ? userStates_1.UserSettings.FiltersView
                    : currentUserSettings === userStates_1.UserSettings.CrowdMapView
                        ? userStates_1.UserSettings.CrowdMapView
                        : userStates_1.UserSettings.MapView,
            },
            {
                key: UrlParamsTypes.sessionId,
                value: "",
            },
            {
                key: UrlParamsTypes.streamId,
                value: "",
            },
            {
                key: UrlParamsTypes.timeFrom,
                value: (0, YearPickerButtons_1.beginningOfTheYear)(currentYear).toString(),
            },
            {
                key: UrlParamsTypes.timeTo,
                value: (0, YearPickerButtons_1.endOfTheYear)(currentYear).toString(),
            },
            { key: UrlParamsTypes.isActive, value: newIsActive.toString() },
        ]);
    }, [sessionType, setUrlParams, currentYear]);
    const streamId = getParam(UrlParamsTypes.streamId, null) !== null
        ? parseInt(getParam(UrlParamsTypes.streamId, "0"))
        : null;
    const tags = getParam(UrlParamsTypes.tags, "");
    const initialThresholds = (0, react_1.useMemo)(() => ({
        min: parseFloat(getParam(UrlParamsTypes.thresholdMin, defaultThresholds.min.toString())),
        low: parseFloat(getParam(UrlParamsTypes.thresholdLow, defaultThresholds.low.toString())),
        middle: parseFloat(getParam(UrlParamsTypes.thresholdMiddle, defaultThresholds.middle.toString())),
        high: parseFloat(getParam(UrlParamsTypes.thresholdHigh, defaultThresholds.high.toString())),
        max: parseFloat(getParam(UrlParamsTypes.thresholdMax, defaultThresholds.max.toString())),
    }), [defaultThresholds]);
    const timeFrom = getParam(UrlParamsTypes.timeFrom, (0, YearPickerButtons_1.beginningOfTheYear)((0, YearPickerButtons_1.getAvailableYears)()[0]).toString());
    const timeTo = getParam(UrlParamsTypes.timeTo, (0, YearPickerButtons_1.endOfTheYear)((0, YearPickerButtons_1.getAvailableYears)()[0]).toString());
    const unitSymbol = getParam(UrlParamsTypes.unitSymbol, filters_1.UnitSymbols.ParticulateMatter);
    const usernames = getParam(UrlParamsTypes.usernames, "");
    (0, react_1.useEffect)(() => {
        debouncedUpdateURL(thresholdValues);
    }, [thresholdValues]);
    const goToUserSettings = (0, react_1.useCallback)((newUserSettings) => {
        setUrlParams([
            {
                key: UrlParamsTypes.previousUserSettings,
                value: currentUserSettings,
            },
            {
                key: UrlParamsTypes.currentUserSettings,
                value: newUserSettings,
            },
        ]);
    }, [searchParams]);
    const revertUserSettingsAndResetIds = (0, react_1.useCallback)(() => {
        const finalPreviousUserSettings = !isMobile && previousUserSettings === userStates_1.UserSettings.CalendarView
            ? userStates_1.UserSettings.MapView
            : previousUserSettings;
        setUrlParams([
            { key: UrlParamsTypes.sessionId, value: "" },
            { key: UrlParamsTypes.streamId, value: "" },
            {
                key: UrlParamsTypes.previousUserSettings,
                value: currentUserSettings,
            },
            {
                key: UrlParamsTypes.currentUserSettings,
                value: finalPreviousUserSettings,
            },
        ]);
    }, [searchParams, previousUserSettings, currentUserSettings, setUrlParams]);
    const setFilter = (0, react_1.useCallback)((key, value) => {
        if (isMobile) {
            setUrlParams([
                {
                    key: key,
                    value: value,
                },
            ]);
        }
        else {
            setUrlParams([
                {
                    key: key,
                    value: value,
                },
                {
                    key: UrlParamsTypes.previousUserSettings,
                    value: currentUserSettings,
                },
                {
                    key: UrlParamsTypes.currentUserSettings,
                    value: currentUserSettings === userStates_1.UserSettings.CrowdMapView
                        ? userStates_1.UserSettings.CrowdMapView
                        : userStates_1.UserSettings.MapView,
                },
                {
                    key: UrlParamsTypes.sessionId,
                    value: "",
                },
                {
                    key: UrlParamsTypes.streamId,
                    value: "",
                },
            ]);
        }
    }, [searchParams]);
    const updateIndoorFilters = (0, react_1.useCallback)((isIndoor) => {
        if (isMobile) {
            setUrlParams([
                {
                    key: UrlParamsTypes.isIndoor,
                    value: isIndoor,
                },
                { key: UrlParamsTypes.usernames, value: "" },
            ]);
        }
        else {
            setUrlParams([
                {
                    key: UrlParamsTypes.isIndoor,
                    value: isIndoor,
                },
                { key: UrlParamsTypes.usernames, value: "" },
                {
                    key: UrlParamsTypes.previousUserSettings,
                    value: currentUserSettings,
                },
                {
                    key: UrlParamsTypes.currentUserSettings,
                    value: currentUserSettings === userStates_1.UserSettings.CrowdMapView
                        ? userStates_1.UserSettings.CrowdMapView
                        : userStates_1.UserSettings.MapView,
                },
                {
                    key: UrlParamsTypes.sessionId,
                    value: "",
                },
                {
                    key: UrlParamsTypes.streamId,
                    value: "",
                },
            ]);
        }
    }, [searchParams]);
    const updateTime = (0, react_1.useCallback)((selectedYear) => {
        setUrlParams([
            {
                key: UrlParamsTypes.previousUserSettings,
                value: isMobile ? previousUserSettings : currentUserSettings,
            },
            {
                key: UrlParamsTypes.currentUserSettings,
                value: isMobile
                    ? userStates_1.UserSettings.FiltersView
                    : currentUserSettings === userStates_1.UserSettings.CrowdMapView
                        ? userStates_1.UserSettings.CrowdMapView
                        : userStates_1.UserSettings.MapView,
            },
            {
                key: UrlParamsTypes.sessionId,
                value: "",
            },
            {
                key: UrlParamsTypes.streamId,
                value: "",
            },
            {
                key: UrlParamsTypes.timeFrom,
                value: (0, YearPickerButtons_1.beginningOfTheYear)(selectedYear).toString(),
            },
            {
                key: UrlParamsTypes.timeTo,
                value: (0, YearPickerButtons_1.endOfTheYear)(selectedYear).toString(),
            },
        ]);
    }, [YearPickerButtons_1.beginningOfTheYear, currentUserSettings, YearPickerButtons_1.endOfTheYear, setUrlParams]);
    const debouncedUpdateURL = (0, react_1.useCallback)((0, lodash_1.debounce)((values) => {
        setSearchParams((prev) => {
            const queryParams = new URLSearchParams(prev);
            queryParams.set(UrlParamsTypes.thresholdMin, values.min.toString());
            values.low !== 0 &&
                queryParams.set(UrlParamsTypes.thresholdLow, values.low.toString());
            values.middle !== 0 &&
                queryParams.set(UrlParamsTypes.thresholdMiddle, values.middle.toString());
            values.high !== 0 &&
                queryParams.set(UrlParamsTypes.thresholdHigh, values.high.toString());
            values.max !== 0 &&
                queryParams.set(UrlParamsTypes.thresholdMax, values.max.toString());
            return queryParams;
        });
    }, 300), [setSearchParams]);
    const setParameterParams = (0, react_1.useCallback)((selectedParameter, sensors) => {
        const sensorData = (0, setSensor_1.setSensor)(selectedParameter, sensors, sessionType);
        const commonParams = [
            {
                key: UrlParamsTypes.previousUserSettings,
                value: currentUserSettings,
            },
            {
                key: UrlParamsTypes.currentUserSettings,
                value: isMobile
                    ? userStates_1.UserSettings.FiltersView
                    : currentUserSettings === userStates_1.UserSettings.CrowdMapView
                        ? userStates_1.UserSettings.CrowdMapView
                        : userStates_1.UserSettings.MapView,
            },
            {
                key: UrlParamsTypes.sessionId,
                value: "",
            },
            {
                key: UrlParamsTypes.streamId,
                value: "",
            },
            {
                key: UrlParamsTypes.measurementType,
                value: selectedParameter,
            },
            {
                key: UrlParamsTypes.sensorName,
                value: sensorData.sensorName,
            },
            {
                key: UrlParamsTypes.unitSymbol,
                value: sensorData.unitSymbol,
            },
        ];
        setUrlParams(commonParams);
        if (isIndoor === booleans_1.TRUE &&
            sensorData.sensorName.startsWith(sensors_1.SensorPrefix.GOVERNMENT)) {
            setUrlParams([
                ...commonParams,
                {
                    key: UrlParamsTypes.isIndoor,
                    value: booleans_1.FALSE,
                },
            ]);
        }
    }, [setUrlParams, setSensor_1.setSensor]);
    const setSensorParams = (0, react_1.useCallback)((selectedSensor, sensors) => {
        const commonParams = [
            {
                key: UrlParamsTypes.previousUserSettings,
                value: currentUserSettings,
            },
            {
                key: UrlParamsTypes.currentUserSettings,
                value: isMobile
                    ? userStates_1.UserSettings.FiltersView
                    : currentUserSettings === userStates_1.UserSettings.CrowdMapView
                        ? userStates_1.UserSettings.CrowdMapView
                        : userStates_1.UserSettings.MapView,
            },
            {
                key: UrlParamsTypes.sessionId,
                value: "",
            },
            {
                key: UrlParamsTypes.streamId,
                value: "",
            },
            {
                key: UrlParamsTypes.sensorName,
                value: selectedSensor,
            },
            {
                key: UrlParamsTypes.unitSymbol,
                value: (0, SensorFilter_1.getSensorUnitSymbol)(selectedSensor, sensors),
            },
        ];
        setUrlParams(commonParams);
        if (isIndoor === booleans_1.TRUE &&
            selectedSensor.startsWith(sensors_1.SensorPrefix.GOVERNMENT)) {
            setUrlParams([
                ...commonParams,
                {
                    key: UrlParamsTypes.isIndoor,
                    value: booleans_1.FALSE,
                },
            ]);
        }
    }, [setUrlParams, SensorFilter_1.getSensorUnitSymbol]);
    return {
        boundEast,
        boundNorth,
        boundSouth,
        boundWest,
        city,
        removeCityParam,
        setSearchParams,
        currentCenter,
        currentUserSettings,
        currentZoom,
        fetchedSessions,
        goToUserSettings,
        gridSize,
        isActive,
        isIndoor,
        limit,
        mapTypeId,
        measurementType,
        offset,
        previousCenter,
        previousUserSettings,
        updatePreviousUserSettings,
        previousZoom,
        revertUserSettingsAndResetIds,
        sensorName,
        sessionId,
        sessionType,
        updateSessionType,
        setFilter,
        setUrlParams,
        streamId,
        initialThresholds,
        searchParams,
        tags,
        timeFrom,
        timeTo,
        updateTime,
        unitSymbol,
        updateFetchedSessions,
        updateLimit,
        updateOffset,
        updateIsActive,
        updateIndoorFilters,
        setSensorParams,
        usernames,
        setParameterParams,
    };
};
exports.useMapParams = useMapParams;
